import React, { Component } from "react";
import i18n from "@/locales/i18n";
export class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "state", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        hasError: false,
      },
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }
  componentDidCatch(error, info) {
    console.error("Application error", error, info);
  }
  render() {
    if (this.state.hasError)
      return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
          <div className="card max-w-md p-8 text-center">
            <h1 className="font-display text-2xl font-bold text-navy-950">
              {i18n.t("errors.unexpected")}
            </h1>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              {i18n.t("errors.unexpectedText")}
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-primary mt-6"
            >
              {i18n.t("errors.refresh")}
            </button>
          </div>
        </div>
      );
    return this.props.children;
  }
}
